export const CHOOSE_LANGUAGE = "CHOOSE_LANGUAGE";
